import React from "react";
import { useLocation } from "react-router-dom";

const pageDetails = {
  "/content-calendar": ["Content Calendar", "Your publishing calendar will live here."],
  "/media-library": ["Media Library", "Your brand media library will live here."],
  "/social-accounts": ["Social Accounts", "Your connected social accounts will live here."],
  "/messages": ["Messages / DMs", "Your customer conversations will live here."],
  "/leads": ["Leads", "Leads from customer conversations will live here."],
  "/analytics": ["Analytics", "Your performance analytics will live here."],
  "/business-profile": ["Business Profile", "Your business information will live here."],
  "/products-services": ["Products & Services", "Your products and services will live here."],
  "/brand-settings": ["Brand Settings", "Your brand identity settings will live here."],
  "/content-preferences": ["Content Preferences", "Your content preferences will live here."],
  "/notifications": ["Notifications", "Your account notifications will live here."],
  "/settings": ["Settings", "Your workspace settings will live here."],
  "/upgrade-plan": ["Upgrade Plan", "Your plan options will live here."],
  "/account/profile": ["User Profile", "Your account profile will live here."],
};

const WorkspacePlaceholder = () => {
  const { pathname } = useLocation();
  const [title, description] = pageDetails[pathname] || ["Workspace", "This workspace page is not available yet."];

  return (
    <section className="workspace-placeholder">
      <div className="workspace-placeholder-mark"><i className="ti ti-layout-grid" aria-hidden="true" /></div>
      <p className="workspace-placeholder-eyebrow">WORKSPACE</p>
      <h1>{title}</h1>
      <p>{description}</p>
    </section>
  );
};

export default WorkspacePlaceholder;
